import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .required('Este campo é obrigatório')
    .email('Email inválido'),
});

export default validationSchema;
